module.exports = __webpack_public_path__ + "static/media/symptoms-of-menopause-news.b3a633e9.jpg";